var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.301 2.508L3.417 7.392a.833.833 0 000 1.178v0a.833.833 0 001.177 0l5.058-5.058c.65-.65.65-1.705 0-2.355v0a1.665 1.665 0 00-2.355 0l-5.54 5.54a2.5 2.5 0 000 3.535v0a2.5 2.5 0 003.536 0l5.366-5.366",
    stroke: "#FA0"
  })));
}
export default __webpack_public_path__ + "static/attach-orange.9ebd9201.svg";
export { SvgAttachOrange as ReactComponent };